import globals from "@homer.core/globals";

const known = {
    provider: ["apple", "facebook", "twitter", "google"],
    status: ["error", "success"],
};
const { searchParams } = new URL(location.href);
const provider = searchParams.get("auth[provider]");
const status = searchParams.get("auth[status]");

if (provider && known.provider.includes(provider) && status && known.status.includes(status)) {
    void globals.demand.request("@apfelkiste/auth");
}
